





import Vue from "vue";

export default Vue.extend({
  name: "StatusTag",
  props: {
    type: {
      type: String,
      default: "gray"
    },
    label: {
      type: String,
      default: ""
    }
  },
  computed: {
    resolveTypeStyle(): Record<string, boolean> {
      return {
        [`status-tag--${this.type}`]: !!this.type
      };
    }
  }
});
